import { Component, Host, h, Prop, State } from '@stencil/core';
import fetchUserProfile from '../../services/fetchUserProfile';
import fetchChannels from '../../services/channel';
import getAuthCookie from '../../services/getAuthCookie'
//import mobileScript from '../../assets/mobile.js';

const fa_script = document.createElement('script');

fa_script.src = "https://kit.fontawesome.com/5ad2be44b5.js";
fa_script.setAttribute("crossorigin", "anonymous");

document.body.appendChild(fa_script);

const pixelScript = document.createElement("script");
pixelScript.innerHTML = `(function() {
            var d=document,h=d.getElementsByTagName('head')[0],s=d.createElement('script'),sc = 'https:' == document.location.protocol ? 'https://' : 'http://';
        s.type='text/javascript';
        s.async=true;
        s.src=sc+'s.dpmsrv.com/dpm_b4c96d80854dd27e76d8cc9e21960eebda52e962.min.js';
        h.appendChild(s);
        })()`;    
document.body.appendChild(pixelScript);


@Component({
  tag: 'portal-header',
  styleUrl: 'portal-header.scss',
  shadow: true,
})
export class PortalHeader {
  /**
   * The dev env
   */
  @Prop() env?: string = 'PROD';
  @Prop() isMobile: boolean = false;
  // Show/Hide Search Bar
  @Prop() search?: boolean = true;
  // Show/Hide Join Btn
  @Prop() join?: boolean = true;

  @Prop() loggedin?: boolean;
  @Prop() manager?: boolean;
  @Prop() channelowner?: boolean;
  @Prop() preauth?: boolean;

  @State() mobileBtnNavBar?:     string = '';
  @State() triggerMobileMenu?:   string  = 'collapsed';
  @State() mobileBtnClasses?:    string  = 'collapsed';
  @State() mobileSearchDisplay?: string  = '';
  @State() mobileMenuDisplay?: string = '';
  @State() mobileSearchClose?:   string  = 'hidden';

  // User State
  @State() isLoggedIn: boolean = false;
  @State() isManager: boolean = false;
  @State() isChannelOwner: boolean = false;
  @State() isPreAuthenticated: boolean = false;

  private getCdnUrl(): string {
	let url = '';
	switch(this.env) {
		case 'int05':
		  url = 'https://assets.int05.brighttalk.net';
		  break;
		case 'test01':
		  url = 'https://assets.test01.brighttalk.net';
		  break;
		case 'stage':
			url = 'https://assets.stage.brighttalk.net';
			break;
		default:
		  url = 'https://assets.brighttalk.com';
	}
	return url;
  }

  private getHostUrl(): string {
	let url = '';
	switch(this.env) {
		case 'int05':
		  url = 'https://www.int05.brighttalk.net';
		  break;
		case 'test01':
		  url = 'https://www.test01.brighttalk.net';
		  break;
		case 'stage':
			url = 'https://www.stage.brighttalk.net';
			break;
		default:
		  url = 'https://www.brighttalk.com';
	}
	return url;
  }

  private mobileMenuToggle = () => {
	console.log(this.mobileMenuDisplay)
    if ( this.mobileMenuDisplay == '' ) {
     this.mobileMenuDisplay = 'collapse';
	 this.triggerMobileMenu = 'collapse';
    } else {
     this.mobileMenuDisplay = '';
	 this.triggerMobileMenu = 'collapsed';
    }
  }

  private mobileSearchToggle = () => {
    if ( this.mobileSearchDisplay == '' ) {
     this.mobileSearchDisplay = 'btalk-mobile-container-search';
     this.mobileSearchClose = 'close';
    } else {
     this.mobileSearchDisplay = '';
     this.mobileSearchClose   = 'hidden';
    }

  }


  async componentWillLoad(){

    let element = document.createElement('link');
    element.setAttribute('rel', 'stylesheet');
    element.setAttribute('href', this.getHostUrl()+'/webcomponent/dist/brighttalk-web-components/brighttalk-web-components.css');
    document.head.appendChild(element);

  const response = await getAuthCookie(this.getHostUrl())

  let userService, channelOwner

  if (response?.tempCData) {
    userService = await fetchUserProfile(this.getHostUrl());
    channelOwner = await fetchChannels(this.getHostUrl());
  }

	this.isLoggedIn = typeof userService != 'undefined' ? userService['isLoggedIn'] : false
	this.isManager = typeof userService != 'undefined' ? userService['isManager'] : false
	this.isChannelOwner = typeof channelOwner != 'undefined' ? channelOwner['isChannelOwner'] : false

	if (userService?.['preAuth'] == true) {
		this.isLoggedIn = true
	}

  let current_url=window.location.pathname
  if(this.isLoggedIn && (current_url=='' || current_url=='/')){
    window.location.href=this.getHostUrl()+'/mybrighttalk/my-feed';
  }
  }

  render() {

	if (this.loggedin){
		this.isLoggedIn = this.loggedin
    let current_url=window.location.pathname
    if(current_url=='' || current_url=='/'){
      window.location.href=this.getHostUrl()+'/mybrighttalk/my-feed';
    }
	}


	if (this.manager){
		this.isManager = this.manager
	}

	if (this.channelowner){
		this.isChannelOwner = this.channelowner
	}

	if (this.preauth){
		this.isLoggedIn = true
    this.isPreAuthenticated = this.preauth
	}

    return (
      <Host style={{'--asseturl': this.getCdnUrl()}}>
        <header  class="masthead masthead-inline header  custom-logo">
		  <div class="btalk-upper-navbar">
			<ul>
				<li data-bdd="Presenter-access"><a href={this.getHostUrl() + `/presenting`} rel="nofollow" target='_blank'>Presenter access</a></li>
				<li data-bdd="BrightTALK-for-business"><a href={this.getHostUrl() + `/business/`} rel="follow" target='_blank'>BrightTALK for business</a></li>
				<li data-bdd="BrightTALK-Central"><a href={this.getHostUrl() + `/central/`} rel="nofollow" target='_blank'>BrightTALK Central</a></li>
			</ul>
		  </div>
          <div class="btalk-navbar">
            <div class="btalk-navbar-inner clearfix">
              <div class="btalk-container max width clearfix">

                <a href={this.isLoggedIn?this.getHostUrl()+'/mybrighttalk/my-feed':this.getHostUrl()} class="btalk-brand-logo img custom-img">
                  <img src={this.getCdnUrl() + `/images/bt-tt-logo.svg`} alt="BrightTALK" />
                </a>

                <button type="button" class={"btalk-btn-navbar collapsed tablets " + this.mobileMenuDisplay} onClick={() => this.mobileMenuToggle()} data-toggle="collapse" data-target=".btalk-nav-wrap.mobile">
                  <i class="fa-solid fa-bars"  aria-hidden="true"></i>
                  <span class="visually-hidden">Navigation</span>
                </button>

               {this.search == true ? <a class="btalk-search-btn" ><span onClick={() => this.mobileSearchToggle() } class="fa-regular fa-magnifying-glass"  aria-hidden="true"></span></a> : '' }

                <div class={"btalk-search-overlay " + this.mobileSearchDisplay }>
                  <div id="btalk-search-topbar" class="btalk-search-form">
                   <search-bar env={ this.getHostUrl() }></search-bar>
                  <span class={"btalk-search-close "  + this.mobileSearchClose } onClick={() => this.mobileSearchToggle() }><i class="btalk-icon-close fal fa-times" aria-hidden="true"></i></span>
                 </div>
                </div>

                <div class="btalk-wrap-topnav">

				{this.search == true ? <search-bar env={ this.getHostUrl() } /> : ''}

                <button type="button" class={'btalk-btn-navbar ' + this.mobileMenuDisplay} onClick={() => this.mobileMenuToggle()}>
				    <i class="fa-solid fa-bars"  aria-hidden="true"></i>
                  <span class="visually-hidden">Navigation</span>
                </button>

                <header-nav env={this.getHostUrl()} isLoggedIn={this.isLoggedIn} isChannelOwner={this.isChannelOwner} isManager={this.isManager} join={this.join} isPreAuthenticated={this.isPreAuthenticated}></header-nav>

              </div>
           </div>
              <div class={"btalk-nav-wrap mobile clearfix in " + this.triggerMobileMenu }>
                <mobile-header-nav env={this.getHostUrl()} isLoggedIn={this.isLoggedIn} isChannelOwner={this.isChannelOwner} isManager={this.isManager} isPreAuthenticated={this.isPreAuthenticated}></mobile-header-nav>
              </div>


          </div>
        </div>
      </header>

    </Host>
  );
 }
}
